import React from "react";
import "../App.css";
import { DxItemGroup, DxTextbox } from "genesys-react-components";
import { GenesysDevIcons } from "genesys-dev-icons";

export function ObjectFilter({ opts, setOpts, tabName }) {
  const filterKeys = Object.keys(opts);

  return (
    <div className="object-filter" key={tabName}>
      <>
        {filterKeys.length !== 0 ? (
          <p className="object-filter-title">Object filters</p>
        ) : (
          ""
        )}
        {filterKeys.map((opt, index) => {
          if (typeof opts[opt] === "object") {
            const [label, items] = [opt, opts[opt].items];

            return (
              <DxItemGroup
                key={`${tabName}-${opt}-${index}`}
                title={label}
                items={items}
                format={opts[opt].format}
                onItemChanged={(item) => {
                  if (opts[opt].format === "dropdown") {
                    setOpts({
                      ...opts,
                      [opt]: { ...opts[opt], [opt]: item.value },
                    })
                  }
                }
                }
                onItemsChanged={(items) => {
                  if (opts[opt].format === "checkbox") {
                    setOpts({
                      ...opts,
                      [opt]: {
                        ...opts[opt],
                        [opt]: items
                          .filter((entry) => entry.isSelected)
                          .map((entry) => entry.item.value),
                      },
                    });
                  }
                }}
              />
            );
          }

          return (
            <DxTextbox
              key={`${tabName}-${opt}-${index}`}
              inputType="text"
              label={opt}
              icon={GenesysDevIcons.AppSearch}
              clearButton={true}
              onChange={(value) => setOpts({ ...opts, [opt]: `${value}` })}
              changeDebounceMs={0}
            />
          );
        })}
      </>
    </div>
  );
}
